import React from 'react';
import { Link } from 'react-scroll';

export default function InfoNavbar() {
  return (
    <div className="container-fluid border-top border-bottom d-none d-sm-block mb40 mt50">
      <div className="container">
        <div className="row">
          <div className="col-12 pt20 pb20 justify-content-between d-flex">
            <Link
              className="cursor-pointer text-dark-gray"
              activeClass="active"
              to="self"
              spy={true}
              smooth={true}
              offset={-50}
              duration={500}
            >
              ¿Qué es el Seguro de Hospitalización?
            </Link>
            |
            <Link
              className="cursor-pointer text-dark-gray"
              activeClass="active"
              to="cover"
              spy={true}
              smooth={true}
              offset={-50}
              duration={500}
            >
              ¿Qué cubre?
            </Link>
            |
            <Link
              className="cursor-pointer text-dark-gray"
              activeClass="active"
              to="benefits"
              spy={true}
              smooth={true}
              offset={-50}
              duration={500}
            >
              Beneficios y Asistencias
            </Link>
            |
            <Link
              className="cursor-pointer text-dark-gray"
              activeClass="active"
              to="requirements"
              spy={true}
              smooth={true}
              offset={-50}
              duration={500}
            >
              Requisitos
            </Link>
            |
            <Link
              className="cursor-pointer text-dark-gray"
              activeClass="active"
              to="notCover"
              spy={true}
              smooth={true}
              offset={-50}
              duration={500}
            >
              ¿Qué no cubre?
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
